import { isLocalePhoneSupported } from "@faire/help-center-self-serve/utils/isLocalePhoneSupported";
import { browserLevelLocaleKey } from "@faire/help-center-utils/serialized-data/getLocale";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";

interface PhoneDescriptionProps {
  formattedWaitTime: string;
}

export const PhoneDescription: React.FC<PhoneDescriptionProps> = ({
  formattedWaitTime,
}) => {
  if (
    isLocalePhoneSupported(browserLevelLocaleKey())
  ) {
    return (
      <StrictLocalMsg
        defaultMessage="Fill out this form, and we'll call you at the number below. The average wait is {formattedWaitTime}."
        description={{
          text: "Description for the user to fill out the form to request a call from Faire support. And the average wait time is 3 minutes for example.",
        }}
        values={{ formattedWaitTime }}
      />
    );
  }

  return (
    <StrictLocalMsg
      defaultMessage="Fill out this form, and we'll call you at the number below. The average wait is {formattedWaitTime}. Please note that calls are currently only available in English."
      description={{
        text: "Description for the user to fill out the form to request a call from Faire support. And the average wait time is 3 minutes for example, and the phone is only available in English.",
      }}
      values={{ formattedWaitTime }}
    />
  );
};
